<template lang="html">
  <div>
    <v-responsive height="100%">
      <v-container fill-height>
        <v-layout align-center justify-start text-xs-center text-sm-left>
          <v-flex>
            <h3 class="display-3">Welcome...</h3>

            <span class="subheading">Welcome to the <i>SunPeak Web Portal</i>, this web portal serves as a central hub for online tools, training and more.</span>

            <v-divider class="my-3"></v-divider>

            <div class="title mb-3">Take a look around!</div>

            <router-link to="/tools" class="clean-link">
              <v-btn color="primary" large outline round >Tools<v-icon right>build</v-icon></v-btn>
            </router-link>
            <router-link to="/training" class="clean-link">
              <v-btn color="primary" large outline round >Training<v-icon right>import_contacts</v-icon></v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('user', {
      isVerified: 'isVerified'
    }),
    ...mapGetters({
      loading: 'loading'
    })
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/pages/Home/Home.vue